import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './css/ServicesSection.css';
import { DynamicIcon } from 'lucide-react/dynamic';
import { Briefcase } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { normalizeServiceIconKey } from '../constants/lucideServiceSectionIcons';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultServices = [
  {
    id: 'company-formation',
    title: 'Company Formation and Licensing',
    summary:
      'Guiding you through GAFI, entity selection, and all licensing formalities.',
    iconKey: 'briefcase',
    targetSlug: 'companies-establishment',
  },
  {
    id: 'mergers-acquisitions',
    title: 'Mergers and Acquisitions (M&A)',
    summary:
      'Structuring, drafting and closing complex M&A transactions and joint ventures.',
    iconKey: 'handshake',
    targetSlug: 'due-diligence',
  },
  {
    id: 'capital-markets-finance',
    title: 'Capital Markets and Finance',
    summary:
      'Advising on IPOs, financings and venture capital structures tailored to your growth.',
    iconKey: 'scale',
    targetSlug: 'capital-markets-finance',
  },
  {
    id: 'operational-commercial',
    title: 'Operational & Commercial Support',
    summary:
      'Providing long‑term support on contracts, employment and intellectual property matters.',
    iconKey: 'briefcase',
    targetSlug: 'drafting-review',
  },
  {
    id: 'dispute-resolution',
    title: 'Dispute Resolution',
    summary:
      'Representing you in litigation and arbitration to safeguard your commercial interests.',
    iconKey: 'shield-check',
    targetSlug: 'dispute-resolution',
  },
  {
    id: 'esop-governance',
    title: 'ESOP & Employee Governance',
    summary:
      'Designing ESOPs and governance frameworks that align talent with shareholder value.',
    iconKey: 'handshake',
    targetSlug: 'employment',
  },
];

const ServicesSection = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState(defaultServices);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/services/section-cards`
        );
        if (Array.isArray(res.data?.cards)) {
          setServices(res.data.cards);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchServices();
  }, []);

  const handleClick = (slug) => {
    navigate(`/services#${slug}`);
  };

  return (
    <motion.section
      className="services-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className="container">
        <div className="services-header d-flex justify-content-between align-items-end mb-5">
          <div className="header-text">
            <p className="services-tag">OUR SERVICE</p>
            <h2 className="services-main-title">Strategic Services for Modern Businesses</h2>
          </div>
          <button className="btn-all-services" onClick={() => navigate('/services')}>
            ALL SERVICES
          </button>
        </div>

        <div className="row g-5">
          {services.map((service) => {
            const iconName = normalizeServiceIconKey(service.iconKey);
            return (
              <div key={service.id} className="col-md-4">
                <button
                  type="button"
                  className="service-card"
                  onClick={() => handleClick(service.targetSlug)}
                >
                  <div className="service-icon-wrapper">
                    <DynamicIcon
                      name={iconName}
                      fallback={Briefcase}
                      size={40}
                      strokeWidth={1.5}
                      className="service-card-icon"
                    />
                  </div>
                  <h3 className="service-item-title">{service.title}</h3>
                  <p className="service-item-desc">{service.summary}</p>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
};

export default ServicesSection;
